import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { CheckCircle, Mail } from 'lucide-react';
import { BrandMark } from '../components/BrandMark';

const SoftDq = () => {
  const navigate = useNavigate();

  useEffect(() => {
    if (typeof window.fbq === 'function') {
      window.fbq('track', 'Lead');
    }
  }, []);

  return (
    <div className="min-h-screen bg-[#2C0616] flex flex-col" data-testid="soft-dq-page">
      <div className="px-4 md:px-6 py-5 border-b-4 border-[#C9A55A]/35">
        <div className="max-w-7xl mx-auto">
          <BrandMark testId="soft-dq-logo" />
        </div>
      </div>

      <div className="flex-1 px-4 py-14 md:py-20">
        <div className="max-w-2xl mx-auto text-center">
          <div className="flex justify-center mb-8">
            <div className="bg-[#220410] border border-[#C9A55A]/35 rounded-full p-5">
              <CheckCircle className="w-14 h-14 text-[#C9A55A]" strokeWidth={1.75} />
            </div>
          </div>

          <h1
            className="text-3xl md:text-5xl font-sans text-[#F5F0E8] mb-5"
            style={{ fontWeight: 800, letterSpacing: '-0.015em', lineHeight: 1.15 }}
            data-testid="soft-dq-headline"
          >
            Thanks For Applying.
          </h1>

          <p className="text-base md:text-lg font-sans text-[#F5F0E8]/75 leading-relaxed mb-10">
            We&apos;ll get back to you.
          </p>

          <div
            className="bg-[#220410] border border-[#C9A55A]/35 rounded-[16px] p-6 md:p-8 text-left"
            data-testid="soft-dq-mail-note"
          >
            <div className="flex items-start gap-4">
              <Mail className="w-6 h-6 text-[#C9A55A] shrink-0 mt-1" strokeWidth={2} />
              <p className="text-base md:text-lg font-sans text-[#F5F0E8] leading-relaxed">
                In the meantime, remember to check your mail — we send{' '}
                <span className="text-[#E0C07A]" style={{ fontWeight: 700 }}>weekly tips</span>{' '}
                to help you grow.
              </p>
            </div>
          </div>

          <div className="mt-10 space-y-4">
            <a
              href="https://www.instagram.com/buildwithprima/"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-block font-sans text-[#C9A55A] hover:text-[#E0C07A] transition-colors"
              style={{ fontWeight: 600 }}
              data-testid="soft-dq-instagram"
            >
              @buildwithprima
            </a>
            <div>
              <button
                onClick={() => navigate('/')}
                className="font-sans text-[#F5F0E8]/60 hover:text-[#F5F0E8] transition-colors"
                data-testid="soft-dq-back-home"
              >
                ← Back to Home
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SoftDq;
